import React from 'react'
import AddP from '../components/AddP'
import Main from '../layouts/Main'

function AddProduct() {
    return (
        <Main>
            <div className="d-flex align-items-center justify-content-between my-4 page-header-breadcrumb flex-wrap gap-2">
                <div>
                    <p className="fw-semibold fs-20 mb-0">Add Product</p>
                </div>
            </div>
            <AddP />
        </Main>
    )
}

export default AddProduct